module.exports = __webpack_public_path__ + "661d441d546e05b15224c5554170470f.svg";